export type InlineTextRun = { text: string; bold: boolean }

/** Remove common inline markdown markers while keeping the inner text. */
export function stripMarkdownEmphasis(text: string): string {
	return text
		.replace(/\*\*(.+?)\*\*/g, '$1')
		.replace(/__(.+?)__/g, '$1')
		.replace(/`([^`]+)`/g, '$1')
		.replace(/\*\*/g, '')
		.replace(/__/g, '')
}

/**
 * Split text into runs where `**bold**` segments are marked bold.
 * Unpaired markers are dropped.
 */
export function parseMarkdownBoldRuns(text: string): InlineTextRun[] {
	const runs: InlineTextRun[] = []
	const re = /\*\*(.+?)\*\*/g
	let lastIndex = 0
	for (const match of text.matchAll(re)) {
		const index = match.index ?? 0
		if (index > lastIndex) {
			runs.push({ text: text.slice(lastIndex, index), bold: false })
		}
		runs.push({ text: match[1], bold: true })
		lastIndex = index + match[0].length
	}
	if (lastIndex < text.length) {
		runs.push({ text: text.slice(lastIndex), bold: false })
	}
	return runs
		.map((run) => ({
			text: run.text.replace(/\*\*/g, '').replace(/__/g, ''),
			bold: run.bold,
		}))
		.filter((run) => run.text.length > 0)
}
